import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from '../../../ManagedUser/Login';
import ManagedInvestorDashboard from '../../../ManagedUser/InvestorDashboard';
import ManagedFundDetails from '../../../ManagedUser/FundDetails';
import ManagedInvestorStatements from '../../../ManagedUser/InvestorStatements';
import ManagedInvestorStatementsOld from '../../../ManagedUser/InvestorStatementsOld';
import ManagedDistributions from '../../../ManagedUser/Distributions';

export default () => (
  <Switch>
    <Route path="/managed/funds/details/:fundCode" component={ManagedFundDetails} />
    <Route path="/managed/distributions" component={ManagedDistributions} />
    <Route path="/managed/funds/statements" component={ManagedInvestorStatements} />
    <Route path="/managed/funds/statements/old" component={ManagedInvestorStatementsOld} />
    <Route path="/managed/login" component={Login} />
    <Route exact path="/managed" component={ManagedInvestorDashboard} />
  </Switch>
);
